import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { Button, Menu, MenuItem, Checkbox, Typography, Divider, Box, TextField, InputAdornment } from '@mui/material';
import { Icon } from '@livable/saas-react-components';
import { SUBSCRIPTION_TERM, getSubscriptionTermLength } from 'src/constants/subscriptionTerm';
import useStyles from './subscriptionsFilterMenuStyles';
const SCOPE_OPTIONS = [{
  value: 'Account',
  label: 'Account'
}, {
  value: 'Property',
  label: 'Property'
}];
const TERM_VALUES = [SUBSCRIPTION_TERM.Monthly, SUBSCRIPTION_TERM.SemiAnnual, SUBSCRIPTION_TERM.Annual];
const STATUS_OPTIONS = [{
  value: 'Draft',
  label: 'Draft'
}, {
  value: 'Active',
  label: 'Active'
}, {
  value: 'Paused',
  label: 'Paused'
}, {
  value: 'Canceled',
  label: 'Canceled'
}];
export function SubscriptionsFilterMenu(_ref) {
  var _filterScope$length, _filterStatus$length, _filterTerm$length, _filterPricings$lengt;
  let filterScope = _ref.filterScope,
    filterStatus = _ref.filterStatus,
    filterTerm = _ref.filterTerm,
    filterPricings = _ref.filterPricings,
    _ref$availablePricing = _ref.availablePricings,
    availablePricings = _ref$availablePricing === void 0 ? [] : _ref$availablePricing,
    onScopeChange = _ref.onScopeChange,
    onStatusChange = _ref.onStatusChange,
    onTermChange = _ref.onTermChange,
    onPricingsChange = _ref.onPricingsChange,
    onApply = _ref.onApply;
  const classes = useStyles();
  const _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    anchorEl = _useState2[0],
    setAnchorEl = _useState2[1];
  const _useState3 = useState(filterScope || []),
    _useState4 = _slicedToArray(_useState3, 2),
    localScope = _useState4[0],
    setLocalScope = _useState4[1];
  const _useState5 = useState(filterStatus || []),
    _useState6 = _slicedToArray(_useState5, 2),
    localStatus = _useState6[0],
    setLocalStatus = _useState6[1];
  const _useState7 = useState(filterTerm || []),
    _useState8 = _slicedToArray(_useState7, 2),
    localTerm = _useState8[0],
    setLocalTerm = _useState8[1];
  const _useState9 = useState(filterPricings || []),
    _useState0 = _slicedToArray(_useState9, 2),
    localPricings = _useState0[0],
    setLocalPricings = _useState0[1];
  const _useState1 = useState(''),
    _useState10 = _slicedToArray(_useState1, 2),
    pricingSearch = _useState10[0],
    setPricingSearch = _useState10[1];
  const open = Boolean(anchorEl);
  const handleOpen = event => {
    setAnchorEl(event.currentTarget);
    setLocalScope(filterScope || []);
    setLocalStatus(filterStatus || []);
    setLocalTerm(filterTerm || []);
    setLocalPricings(filterPricings || []);
    setPricingSearch('');
  };
  const handleClose = () => setAnchorEl(null);
  const toggleScope = value => {
    setLocalScope(prev => prev.includes(value) ? prev.filter(v => v !== value) : [...prev, value]);
  };
  const toggleStatus = value => {
    setLocalStatus(prev => prev.includes(value) ? prev.filter(v => v !== value) : [...prev, value]);
  };
  const toggleTerm = value => {
    setLocalTerm(prev => prev.includes(value) ? prev.filter(v => v !== value) : [...prev, value]);
  };
  const togglePricings = value => {
    setLocalPricings(prev => prev.includes(value) ? prev.filter(v => v !== value) : [...prev, value]);
  };
  const handleApply = () => {
    onScopeChange(localScope);
    onStatusChange(localStatus);
    onTermChange(localTerm);
    onPricingsChange(localPricings);
    onApply === null || onApply === void 0 || onApply();
    handleClose();
  };
  const handleClear = () => {
    setLocalScope([]);
    setLocalStatus([]);
    setLocalTerm([]);
    setLocalPricings([]);
    onScopeChange([]);
    onStatusChange([]);
    onTermChange([]);
    onPricingsChange([]);
    onApply === null || onApply === void 0 || onApply();
    handleClose();
  };
  const activeFilterCount = ((_filterScope$length = filterScope === null || filterScope === void 0 ? void 0 : filterScope.length) !== null && _filterScope$length !== void 0 ? _filterScope$length : 0) + ((_filterStatus$length = filterStatus === null || filterStatus === void 0 ? void 0 : filterStatus.length) !== null && _filterStatus$length !== void 0 ? _filterStatus$length : 0) + ((_filterTerm$length = filterTerm === null || filterTerm === void 0 ? void 0 : filterTerm.length) !== null && _filterTerm$length !== void 0 ? _filterTerm$length : 0) + ((_filterPricings$lengt = filterPricings === null || filterPricings === void 0 ? void 0 : filterPricings.length) !== null && _filterPricings$lengt !== void 0 ? _filterPricings$lengt : 0);
  const pricingSearchLower = (pricingSearch || '').trim().toLowerCase();
  const filteredPricings = !pricingSearchLower ? availablePricings : availablePricings.filter(p => (p.label || '').toLowerCase().includes(pricingSearchLower));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    variant: "outlined",
    size: "small",
    className: classes.filterButton,
    "aria-controls": "subscriptions-filter-menu",
    "aria-haspopup": "true",
    "aria-expanded": open ? 'true' : undefined,
    onClick: handleOpen,
    startIcon: /*#__PURE__*/React.createElement(Icon, {
      type: "filter"
    })
  }, "Filter", activeFilterCount > 0 && /*#__PURE__*/React.createElement("span", {
    className: classes.filterBadge
  }, activeFilterCount)), /*#__PURE__*/React.createElement(Menu, {
    id: "subscriptions-filter-menu",
    anchorEl: anchorEl,
    open: open,
    onClose: handleClose,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right'
    },
    PaperProps: {
      className: classes.menuPaper
    },
    MenuListProps: {
      className: classes.menuList
    }
  }, /*#__PURE__*/React.createElement(Box, {
    className: classes.menuScrollContent
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2",
    color: "text.secondary",
    className: classes.sectionLabel
  }, "Scope"), SCOPE_OPTIONS.map(opt => /*#__PURE__*/React.createElement(MenuItem, {
    key: opt.value,
    onClick: () => toggleScope(opt.value),
    disableRipple: true,
    className: classes.menuItem
  }, /*#__PURE__*/React.createElement(Checkbox, {
    size: "small",
    checked: localScope.includes(opt.value),
    disableRipple: true
  }), opt.label)), /*#__PURE__*/React.createElement(Divider, {
    className: classes.divider
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2",
    color: "text.secondary",
    className: classes.sectionLabel
  }, "Status"), STATUS_OPTIONS.map(opt => /*#__PURE__*/React.createElement(MenuItem, {
    key: opt.value,
    onClick: () => toggleStatus(opt.value),
    disableRipple: true,
    className: classes.menuItem
  }, /*#__PURE__*/React.createElement(Checkbox, {
    size: "small",
    checked: localStatus.includes(opt.value),
    disableRipple: true
  }), opt.label)), /*#__PURE__*/React.createElement(Divider, {
    className: classes.divider
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2",
    color: "text.secondary",
    className: classes.sectionLabel
  }, "Term"), TERM_VALUES.map(value => /*#__PURE__*/React.createElement(MenuItem, {
    key: value,
    onClick: () => toggleTerm(value),
    disableRipple: true,
    className: classes.menuItem
  }, /*#__PURE__*/React.createElement(Checkbox, {
    size: "small",
    checked: localTerm.includes(value),
    disableRipple: true
  }), getSubscriptionTermLength(value))), /*#__PURE__*/React.createElement(Divider, {
    className: classes.divider
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2",
    color: "text.secondary",
    className: classes.sectionLabel
  }, "Pricings"), /*#__PURE__*/React.createElement(TextField, {
    size: "small",
    placeholder: "Search pricings...",
    value: pricingSearch,
    onChange: e => setPricingSearch(e.target.value),
    variant: "outlined",
    className: classes.pricingSearchInput,
    InputProps: {
      startAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
        position: "start"
      }, /*#__PURE__*/React.createElement(Icon, {
        type: "search"
      }))
    },
    onClick: e => e.stopPropagation()
  }), /*#__PURE__*/React.createElement(Box, {
    className: classes.pricingsList
  }, availablePricings.length === 0 ? /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "text.secondary",
    className: classes.pricingsListEmpty
  }, "No pricings in subscriptions") : filteredPricings.length === 0 ? /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "text.secondary",
    className: classes.pricingsListEmpty
  }, "No matching pricings") : filteredPricings.map(p => /*#__PURE__*/React.createElement(MenuItem, {
    key: p.id,
    onClick: () => togglePricings(p.id),
    disableRipple: true,
    className: classes.menuItem
  }, /*#__PURE__*/React.createElement(Checkbox, {
    size: "small",
    checked: localPricings.includes(p.id),
    disableRipple: true
  }), p.label)))), /*#__PURE__*/React.createElement(Box, {
    className: classes.actionBar
  }, /*#__PURE__*/React.createElement(Button, {
    size: "small",
    onClick: handleClear
  }, "Clear"), /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    size: "small",
    onClick: handleApply
  }, "Apply"))));
}